export default{
    login_email:'',
    isBtnLoading: true,
    personalInfo:{
      "memberName": "",
      "mobile": "",
      "BOD": "",
      "adr_address": "",
      "adr_unit": "",
      "adr_city": "",
      "adr_state": "",
      "adr_zip": "",
      "occupation": "",
      "country": "",
      "step": -1,
      "SSN":'',
      "cardType":'driverLicense',
      "image":{
        driverLicense:{
          image1: false,
          image2: false,
        },
        idCard:{
          image1: false,
          image2: false,
        },
        passport:{
          image1: false,
          image2: false,
        }
      },
      "image1":'',
      "image2":'',
      limited:{
        Borrow:'X',
        Deposit:'',
        Exchange:'X',
        TermDeposit:'',
        Withdraw:'',
      }
    },
    personalInfo2:{
      email: '',
      cellphone: '',
      firstName: '',
      middleName: '',
      lastName: '',
      invitecode:'',
      isVerify:-1,
      quotalevel:'',
      checkVerify:-1,
      isUpgrade:0,
    },
    assetsObj:{},
    btcAddress: '',
    usdtAddress:'',
    recurringType:'1',
    recurringObj:{},
    priceObj:{},
    withdraw:'',
    security:{},
}


// WEBPACK FOOTER //
// ./src/store/state.js